import { makeStyles } from "@material-ui/core/styles";

export const useSelectFieldChipStyles = makeStyles(() => ({
  chip: {
    fontSize: "0.95rem",
    marginRight: "5px",
  },
  chips: {
    marginTop: "10px",
  },
}));
